export function CollateralAlertsPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Collateral Alerts</h1>
      <p className="text-muted-foreground">Monitor collateral health alerts.</p>
    </div>
  );
}
